// Shapes raw Realtime Database snapshots into what the payment screens render.
// Pure functions so the derivation is testable without Firebase.

// Merges the three admin feeds into one payments map:
//   squareTransactions – mirrored Square payments keyed by payment id
//   postedPayments     – ids that have been (or are being) posted to an account
//   users              – for the resident's name, matched on squareCustomerId
// The `posted` flag is derived from the live postedPayments feed, so it flips
// the moment the auto-poster or a manual post claims a payment.
export const decoratePayments = (transactions, postedPayments, users) => {
  const usersByCustomerId = {};
  Object.values(users || {}).forEach((user) => {
    if (user?.squareCustomerId) usersByCustomerId[user.squareCustomerId] = user;
  });

  const result = {};
  Object.entries(transactions || {}).forEach(([key, txn]) => {
    if (!txn) return;
    const id = txn.id || key;
    const linked = usersByCustomerId[txn.customerId];
    result[key] = {
      ...txn,
      id,
      firstName: linked?.firstName,
      lastName: linked?.lastName,
      posted: Boolean(postedPayments?.[id]),
    };
  });
  return result;
};

// Payments map → array, newest first. Entries without a createdAt sort last.
export const paymentsNewestFirst = (payments) =>
  Object.entries(payments || {})
    .filter(([, payment]) => Boolean(payment))
    .map(([key, payment]) => ({ ...payment, id: payment.id || key }))
    .sort((a, b) => {
      const ta = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const tb = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return tb - ta;
    });
